import { useNavigate } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';

import { Page } from '@common/ui/Page';

import { AccessRequestForm } from '@NewRequest/organisms/AccessRequestForm';
import routes from '@routes';

export const SUBMITTED_QUERY_PARAM = 'submitted';

export default function OnboardingAccessRequestFormPage() {
  const navigate = useNavigate();

  const handleBackButtonClick = () => {
    window.parent.postMessage(
      {
        type: 'back-button',
      },
      ADMIN_PORTAL_URL || '*',
    );
  };

  return (
    <Page title="See it in action - request access as a user">
      <Stack spacing={2} width="48rem">
        <Typography variant="body2">
          Apono helps you gain access to resources in your organization. Pick a bundle or create a custom list of
          resources and permissions below.Your request will be processed according to the relevant access policy. Once
          approved, access details will be sent to you and the access will be active until the set expiration date.
        </Typography>
        <AccessRequestForm
          onSuccess={() => navigate(`${routes.OnboardingAccessRequestFetching.path}?${SUBMITTED_QUERY_PARAM}=true`)}
          onClickBack={handleBackButtonClick}
          templatesEnabled={false}
        />
      </Stack>
    </Page>
  );
}
